import React from "react";
import { useLocation } from "react-router-dom";

// Zentrale Impressum/Datenschutz-Zeile fuer oeffentliche Seiten ohne eigene Fusszeile.
const OWN_FOOTER = ["/", "/lp-preview", "/pricing", "/status", "/schneller-zugang", "/willkommen-zurueck", "/quickcheck", "/impressum", "/datenschutz", "/co-creator/result", "/lp/kt400-team", "/lp/kt400-privat", "/lp/kt400-pause", "/lp/kt400-wahl"];
const PRIVATE_PREFIXES = ["/dashboard", "/cockpit", "/admin", "/mein-muster", "/andere-verstehen", "/wirkung-gestalten", "/videokurs", "/anliegen", "/profil", "/mitgestalten", "/feedback", "/cancel", "/challenge/tag", "/challenge/wrapup"];

const isExcluded = (path) => {
  const p = path.length > 1 ? path.replace(/\/+$/, "") : path;
  if (OWN_FOOTER.includes(p) || /^\/webinar\/[^/]+\/anmeldung$/.test(p)) return true;
  return PRIVATE_PREFIXES.some((pre) => p === pre || p.startsWith(pre + "/"));
};

const linkCls = "hover:text-slate-800 underline-offset-4 hover:underline transition-colors";

export const LegalFooterLine = () => {
  const { pathname } = useLocation();
  if (isExcluded(pathname)) return null;
  return (
    <footer data-testid="legal-footer-line" className="w-full bg-transparent py-6 text-center text-xs text-slate-500">
      <a href="https://effektiv-kommunizieren.de/impressum" target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="legal-footer-impressum">Impressum</a>
      <span className="mx-2" aria-hidden="true">·</span>
      <a href="https://effektiv-kommunizieren.de/datenschutz" target="_blank" rel="noopener noreferrer" className={linkCls} data-testid="legal-footer-datenschutz">Datenschutz</a>
    </footer>
  );
};

export default LegalFooterLine;
